/* eslint-disable unicorn/filename-case -- TODO rename later */
import { useQuery } from "@tanstack/react-query";

import { userQueryOptions } from "~/api/user/userQueryOptions";
import { userToInternalUser } from "~/api/user/userToInternalUser";

export const useUsers = (options?: { enabled?: boolean }) =>
  useQuery({
    ...userQueryOptions.all(),
    select: (users) => users.map(userToInternalUser),
    enabled: options?.enabled,
  });
